export default "__VITE_ASSET__7ab2f97f__"